// Dummy data for purchase notifications

// Fake customers from different Indian cities
export const customers = [
  "Amit from Mumbai",
  "Rahul from Bangalore",
  "Sneha from Pune",
  "Neha from Delhi",
  "Karan from Ahmedabad",
  "Priya from Chennai",
  "Vikram from Hyderabad",
  "Anjali from Jaipur",
  "Rohit from Indore",
  "Pooja from Surat",
  "Arun from Kolkata",
  "Meera from Lucknow",
  "Deepak from Chandigarh",
  "Kavita from Nagpur",
  "Sanjay from Patna",
  "Ritu from Bhopal",
  "Manish from Coimbatore",
  "Swati from Nashik",
  "Rajesh from Vadodara",
  "Nisha from Kochi"
];

// Lucky Draw entries
export const draws = [
  {
    name: "iPhone 15 Pro Max Draw",
    image: "https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "MacBook Air M2 Draw",
    image: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "PlayStation 5 Draw",
    image: "https://images.unsplash.com/photo-1606813907291-d86efa9b94db?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "Samsung Galaxy S24 Draw",
    image: "https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "Apple Watch Ultra Draw",
    image: "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "Sony WH-1000XM5 Draw",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "iPad Pro 12.9 Draw",
    image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=100&h=100&fit=crop",
    type: "draw"
  },
  {
    name: "Gold Coin 10gm Draw",
    image: "https://images.unsplash.com/photo-1610375461246-83df859d849d?w=100&h=100&fit=crop",
    type: "draw"
  }
];

// Products that can be purchased
export const products = [
  {
    name: "Wireless Earbuds",
    image: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=100&h=100&fit=crop",
    price: "₹1,999",
    type: "product"
  },
  {
    name: "Smart Watch",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=100&h=100&fit=crop",
    price: "₹4,999",
    type: "product"
  },
  {
    name: "Bluetooth Speaker",
    image: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=100&h=100&fit=crop",
    price: "₹2,499",
    type: "product"
  },
  {
    name: "Power Bank 20000mAh",
    image: "https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=100&h=100&fit=crop",
    price: "₹1,299",
    type: "product"
  },
  {
    name: "Gaming Mouse",
    image: "https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=100&h=100&fit=crop",
    price: "₹899",
    type: "product"
  },
  {
    name: "Mechanical Keyboard",
    image: "https://images.unsplash.com/photo-1511467687858-23d96c32e4ae?w=100&h=100&fit=crop",
    price: "₹3,499",
    type: "product"
  },
  {
    name: "USB-C Hub",
    image: "https://images.unsplash.com/photo-1625723044792-44de16ccb4e9?w=100&h=100&fit=crop",
    price: "₹1,599",
    type: "product"
  },
  {
    name: "Laptop Stand",
    image: "https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=100&h=100&fit=crop",
    price: "₹999",
    type: "product"
  }
];

// Time ago texts for variety
export const timeAgoTexts = [
  "Just now",
  "A moment ago",
  "Few seconds ago",
  "1 minute ago",
  "2 minutes ago"
];

// Get random item from array
export const getRandomItem = (array) => {
  return array[Math.floor(Math.random() * array.length)];
};

// Generate a random purchase notification
export const generateRandomPurchase = () => {
  const customer = getRandomItem(customers);
  const timeAgo = getRandomItem(timeAgoTexts);

  // Randomly choose between draw and product (50-50 chance)
  const isDraw = Math.random() < 0.5;
  const item = isDraw ? getRandomItem(draws) : getRandomItem(products);

  return {
    customer,
    item,
    timeAgo,
    isDraw
  };
};
